<template>
  <div id="dashboard-page" style="margin-bottom:55px;">
    <b-card>
      <b-row>
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/items">Items</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <div v-if="isLoading" style="z-index: 1000;">
        <div class="text-center text-primary my-2 h-100">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
        </div>
      </div>
      <div v-else>
        <b-form class="mt-3 mx-2">
          <b-row>
            <b-col md="6">
              <b-row>
                <b-col md="4"><label class="labels">Product Type</label></b-col>
                <b-col md="8"
                  ><p>{{ model.productType !== '' ? model.productType : '-' }}</p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Item ID</label></b-col>
                <b-col md="8"
                  ><p>{{ model.itemId !== null ? model.itemId : '-' }}</p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Name</label></b-col>
                <b-col md="8"
                  ><p style="white-space: pre-line; word-wrap: break-word; hyphens: auto;">
                    {{ model.name !== null ? model.name : '-'}}
                  </p>
                  <!-- <b-card class="border-none">
                  <wysiwyg v-model="model.name" placeholder="" readonly />
                </b-card> -->
                  </b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Item Category</label></b-col>
                <b-col md="8"
                  ><p>{{ model.itemCategory !== null ? model.itemCategory.name : '-' }}</p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Item Unit</label></b-col>
                <b-col md="8"
                  ><p>{{ model.itemUnit !== null ? model.itemUnit.name : '-' }}</p></b-col
                >
              </b-row>
            </b-col>
            <viewer>
              <b-row>
                <b-col md="4"><label class="labels">Product Image</label></b-col>
                <b-col md="3">
                  <!-- <p
                              class="text-secondary text-center border p-5 d-flex"
                              v-if="model.image == null"
                            >
                              <i>No Photo Submitted</i>
                            </p> -->
                  <b-img
                    :src="model.image"
                    class="img-responsive pointer"
                    v-b-tooltip.focus
                    width="300"
                    height="200"
                  />
                </b-col>
              </b-row>
            </viewer>

            <b-col md="6">
              <b-row>
                <b-col md="4"><label class="labels"> Supplier Reference</label></b-col>
                <b-col md="8"
                  ><p>
                    {{
                      model.itemSupplierReferenceName !== '' ? model.itemSupplierReferenceName : '-'
                    }}
                  </p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Description</label></b-col>
                <b-col md="8"
                  >
                  <p style="white-space: pre-wrap; padding:6px; border: 1px solid #f3f3fd;">{{ model.itemDescription !==null ? model.itemDescription : '-'}}</p>
                  <!-- <wysiwyg v-model="model.itemDescription" placeholder="" readonly /> -->
                  
                  
                  </b-col
                >
              </b-row>

              <b-row>
                <!-- <b-col md="4"><label class="labels">Price <label style="text-transform:lowercase!important; font-size:10px!important;"> / unit</label></label></b-col> -->
                <b-col md="4"><label class="labels">Normal Price</label></b-col>
                <b-col md="8"
                  ><p>
                    {{ dataAccount.account.currency }}
                    {{ model.normalPrice !== null ? formatPrice(model.normalPrice) : '-' }}
                  </p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Corporate Price</label></b-col>
                <b-col md="8"
                  ><p>
                    {{ dataAccount.account.currency }}
                    {{ model.corporatePrice !== null ? formatPrice(model.corporatePrice) : '-' }}
                  </p></b-col
                >
              </b-row>
              <b-row>
                <b-col md="4"><label class="labels">Cost Of Goods</label></b-col>
                <b-col md="8"
                  ><p>
                    {{ dataAccount.account.currency }}
                    {{ model.costOfGoods !== null ? formatPrice(model.costOfGoods) : '-' }}
                  </p></b-col
                >
              </b-row>
            </b-col>
          </b-row>
        </b-form>

      <b-button class="mt-3" :to="'/sales/items'" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
      >
      <b-button
        class="mt-3 float-right"
        :to="'/sales/items/' + $route.params.uuid + '/edit'"
        variant="warning"
        ><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button
      >
      </div>
    </b-card>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
import wysiwyg from 'vue-wysiwyg';
Vue.use(wysiwyg, {
  hideModules: {
    headings: true,
    code: true,
    link: true,
    image: true,
    table: true,
    unorderedList: true,
    separator: true,
    maxHeight: '100px'
  },
}); // config is optional. more below
Vue.use(Viewer);
export default {
  name: 'items-details',
  data() {
    return {
      isLoading: false,
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        itemList: window.AppConfig.apiUrl + 'item-list',
      },
      model: {
        itemId: '',
        productType: '',
        name: '',
        itemCategory: {
          name: null,
        },
        itemMerk: {
          name: null,
        },
        itemUnit: {
          name: null,
        },
        image: null,
        unitLabel: '',
        normalPrice: null,
        itemSupplierReferenceName: '',
        // supplierReferenceName: null,
        itemDescription: null,
        costOfGoods: null,
      },
      currency: '',
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.isLoading = true;
      this.$http.get(this.apiUrl.itemList + '/' + this.$route.params.uuid).then((response) => {
        this.model.itemId =
          response.data.itemId !== null && response.data.itemId !== 'null'
            ? response.data.itemId
            : '-';
        this.model.productType =
          response.data.productType !== null && response.data.productType !== 'null'
            ? response.data.productType
            : '-';
        this.model.name =
          response.data.name !== null && response.data.name !== 'null' ? response.data.name : '-';
        this.model.itemCategory =
          response.data.itemCategory !== null && response.data.itemCategory !== 'null'
            ? response.data.itemCategory
            : '-';
        this.model.itemUnit =
          response.data.itemUnit !== null && response.data.itemUnit !== 'null'
            ? response.data.itemUnit
            : '-';
        this.model.itemDescription =
          response.data.itemDescription !== null && response.data.itemDescription !== 'null'
            ? response.data.itemDescription
            : '-';
        this.model.normalPrice =
          response.data.normalPrice !== null && response.data.normalPrice !== 'null'
            ? response.data.normalPrice
            : '-';
        this.model.corporatePrice =
          response.data.corporatePrice !== null && response.data.corporatePrice !== 'null'
            ? response.data.corporatePrice
            : '-';
        this.model.costOfGoods =
          response.data.costOfGoods !== null && response.data.costOfGoods !== 'null'
            ? response.data.costOfGoods
            : '-';
        this.model.itemMerk = response.data.itemMerk !== null ? response.data.itemMerk.name : '-';
        this.model.image = response.data.image !== null ? response.data.image : '-';
        this.model.itemSupplierReferenceName =
          response.data.itemSupplierReferenceName !== null
            ? response.data.itemSupplierReferenceName
            : '-';
        this.currency = response.data.itemCategory.currency;
        this.isLoading = false;
      });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm A');
      } else {
        return '-';
      }
    },
    goBack() {
      window.goBack(this);
    },
    getStatusColor(val) {
      if (val) {
        return 'success';
      } else {
        return 'secondary';
      }
    },
    getStatusName(val) {
      if (val) {
        return 'Headquarters';
      } else {
        return 'Branch';
      }
    },
  },
};
</script>
<style scoped>
@import '~vue-wysiwyg/dist/vueWysiwyg.css';
</style>
